import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import AppShell from 'app/layout/AppShell';
import dashRoutes from 'routes/dash.jsx';

const hasSession = () => {
  const username = sessionStorage.getItem('username');
  const user = sessionStorage.getItem('user');
  return !!username && !!user && user !== 'undefined';
};

// Contenedor de las pantallas con sesion: el shell y la tabla de rutas.
const Dash = () => {
  const allowed = hasSession();

  useEffect(() => {
    if (!allowed) {
      window.location.href = '/login';
    }
  }, [allowed]);

  if (!allowed) {
    return null;
  }

  return (
    <AppShell>
      <Routes>
        {dashRoutes.map((prop) => (
          <Route path={prop.path} element={<prop.component />} key={prop.path} />
        ))}
      </Routes>
    </AppShell>
  );
};

export default Dash;
